import React, { useCallback, useEffect, useState, useRef } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import useFetch from "../../hooks/useFetch";
import DatePicker from "react-datepicker";

import axios from "axios";

const ConsultantForm = ({ consultantId, onSave }) => {
  const location = useLocation();
  const authState = useSelector((state) => state.authReducer);
  const [fetchData, { loading }] = useFetch();

  const [userId, setUserId] = useState(authState.user._id);
  const [userCode, setUserCode] = useState(authState.user.think5whyscode);
  const [userName, setUserName] = useState(authState.user.name);
  const [saved, setSaved] = useState(false);
  const [saveClicked, setSaveClicked] = useState(false);

  const [formData, setFormData] = useState({
    userCode: userCode,
    name: userName,
    businessName: "",
    city: "",
    country: "India",
    mobile: "",
    email: "",
    website: "",
    isCounsellor: true,
    isConsultant: true,
    briefBio: "",
    workStatus: "",
    nextSchedule: "",
    clientList: "",
    charges: 0,
    chargesCurrency: "₹",
    chargesRemarks: "",
    ratingCount: 0,
    rating: 0,
    reviews: [],
    isActive: false,
    isDeleted: false,
    isAvailableFree: false,
    dateCreated: new Date(),
  });

  useEffect(() => {
    if (consultantId) {
      axios
        .get(`/api/consultants/${consultantId}`)
        .then((response) => {
          setFormData(response.data);
        })
        .catch((error) => {
          console.error("Error fetching consultant data:", error);
        });
    }
  }, [consultantId]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const [errors, setErrors] = useState([]);

  const validateForm = () => {
    const validationErrors = [];
    if (!formData.name) validationErrors.push("Name is required.");
    if (!formData.mobile) validationErrors.push("Mobile is required.");
    if (!formData.email) validationErrors.push("Email is required.");
    if (!formData.city) validationErrors.push("City is required.");
    if (!formData.country) validationErrors.push("Country is required.");
    if (!formData.briefBio) validationErrors.push("Brief bio is required.");
    if (!formData.charges) validationErrors.push("Charges are required.");
    if (!formData.chargesCurrency)
      validationErrors.push("Charges currency is required.");
    if (!formData.workStatus) validationErrors.push("Work status is required.");

    const mobileRegex = /^[6-9]\d{9}$/;
    if (formData.mobile && !mobileRegex.test(formData.mobile)) {
      validationErrors.push("Mobile must be a valid 10-digit number.");
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (formData.email && !emailRegex.test(formData.email)) {
      validationErrors.push("Email must be in a valid format.");
    }

    const websiteRegex =
      /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+\/?$/;
    if (formData.website && !websiteRegex.test(formData.website)) {
      validationErrors.push("Website must be in a valid format.");
    }

    setErrors(validationErrors);

    return validationErrors.length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(validateForm() ? "validated" : "not validated");
    if (!validateForm()) {
      return;
    }
    try {
      const config = {
        url: "/consultants/save",
        method: "post",
        data: { userId: userId, formData: formData },
        headers: { Authorization: authState.token },
      };
      const response = await fetchData(config);
      setSaved(true);
      setSaveClicked(true);
    } catch (error) {
      console.error(
        "An error occurred while saving the Counsellor / Consultant Data:",
        error,
      );
    }
  };

  return (
    <div className="py-4 px-4 bg-black">
      <h1 className="text-xl font-bold text-center mb-6 border-b border-blue-400 ">
        Counsellor / Consultant Enrollment Form
      </h1>
      <div className="flex flex-col gap-6">
        <div>
          <label htmlFor="name" className="block text-white">
            Name:
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            className="mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label htmlFor="briefBio" className="block text-white">
            Brief Bio:
          </label>
          <textarea
            id="briefBio"
            name="briefBio"
            value={formData.briefBio}
            onChange={handleInputChange}
            style={{width: "200px"}}
            className="bg-gray-800 text-white mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500 h-[400px]"
          ></textarea>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="city" className="block text-white">
              City:
            </label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleInputChange}
              className="mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label htmlFor="country" className="block text-white">
              Country:
            </label>
            <input
              type="text"
              id="country"
              name="country"
              value={formData.country}
              onChange={handleInputChange}
              className="mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label htmlFor="mobile" className="block text-white">
              Mobile:
            </label>
            <input
              type="text"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleInputChange}
              className="mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
          <div>
            <label htmlFor="email" className="block text-white">
              Email:
            </label>
            <input
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              className="mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div>
          <label htmlFor="website" className="block text-white">
            Website:
          </label>
          <input
            type="text"
            id="website"
            name="website"
            value={formData.website}
            onChange={handleInputChange}
            className="mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 mt-4">
        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="isCounsellor"
            checked={formData.isCounsellor}
            onChange={handleInputChange}
            className="h-5 w-5 text-blue-600"
          />
          <span className="ml-2 text-white">Is Counsellor</span>
        </label>

        <label className="inline-flex items-center">
          <input
            type="checkbox"
            name="isConsultant"
            checked={formData.isConsultant}
            onChange={handleInputChange}
            className="h-5 w-5 text-blue-600"
          />
          <span className="ml-2 text-white">Is Business Consultant</span>
        </label>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
        <div>
          <label className="block text-white">Charges (per minute):</label>
          <input
            name="charges"
            value={formData.charges}
            onChange={handleInputChange}
            className="bg-gray-800 text-white mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div>
          <label className="block text-white">Currency:</label>
          <input
            name="chargesCurrency"
            value={formData.chargesCurrency}
            onChange={handleInputChange}
            className="bg-gray-800 text-white mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="md:col-span-3">
          <label className="block text-white">About Charges:</label>
          <input
            name="chargesRemarks"
            value={formData.chargesRemarks}
            onChange={handleInputChange}
            className="bg-gray-800 text-white mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
      </div>
      <div className="mt-4">
        <label htmlFor="workStatus" className="block text-white">
          Current Availability Status:
        </label>
        <select
          id="workStatus"
          name="workStatus"
          value={formData.workStatus}
          onChange={handleInputChange}
          className="bg-gray-800 text-white w-full h-10 mt-2 px-2 py-1 border rounded-lg focus:ring-2 focus:ring-blue-500"
        >
          <option value="">--- Select Availability ---</option>
          <option value="Available">Available</option>
          <option value="Unavailable">Unavailable</option>
          <option value="Prior Appointment">Prior Appointment</option>
        </select>
      </div>

      <div className="mt-6">
        <label className="flex items-center gap-3 cursor-pointer">
          <input
            type="checkbox"
            name="isAvailableFree"
            checked={formData.isAvailableFree}
            onChange={handleInputChange}
            className="w-5 h-5 accent-emerald-500"
          />
          <span className="text-white">
            Available for Free Support on FoundHer (Young Women Entrepreneurs)
          </span>
        </label>
      </div>

      {formData.workStatus === "Prior Appointment" && (
        <div className="mt-4">
          <label className="block text-white">
            I am available on prior appointment:
          </label>
          <input
            name="nextSchedule"
            value={formData.nextSchedule}
            onChange={handleInputChange}
            className="bg-gray-800 text-white mt-2 p-2 w-full border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
      )}
      <div className="mt-4">
        <label className="block text-white">Business Name / Title:</label>
        <input
          type="text"
          name="businessName"
          value={formData.businessName}
          onChange={handleInputChange}
          className="w-full mt-2 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />
      </div>
      <div className="mt-4">
        <label className="block text-white">Client / Testimonials:</label>
        <textarea
          name="clientList"
          value={formData.clientList}
          onChange={handleInputChange}
          style={{width: "200px"}}
          className="w-full mt-2 p-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
        />
      </div>
      {errors.length > 0 && (
        <div className="flex flex-col items-center text-red-500 mt-4">
          {errors.map((err, i) => (
            <p key={i}>{err}</p>
          ))}
        </div>
      )}
      <div className="text-center mt-6">
        <button
          onClick={handleSubmit}
          disabled={saved}
          className={`w-fit px-2 py-1 rounded-lg focus:ring-4 focus:ring-blue-300 text-white
            ${saved ? "bg-gray-500 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"}`}
        >
          {saved ? "Enrolled" : "Enroll"}
        </button>
      </div>

      <footer className="bg-black border-t border-blue-400 text-white py-3 px-4 mt-8">
        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs sm:text-sm text-center">
            © 2025 Think5Whys Global DeepTech Solutions.
          </p>
          <div className="flex flex-row gap-4 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="hover:text-purple-200">
              About
            </Link>
            <Link to="/privacy-policy" className="hover:text-purple-200">
              Privacy Policy
            </Link>
            <Link to="/terms-of-use" className="hover:text-purple-200">
              Terms of Use
            </Link>
            <Link to="/contact-us" className="hover:text-purple-200">
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default ConsultantForm;
